var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.83 42.5 2.67-2.66-2.67-2.67m20.46-8.66a4.67 4.67 0 0 1 2.22 3.55c0 3.27-5.2 6.07-12.56 7.22",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71 28.51a4.67 4.67 0 0 0-2.22 3.55c0 4.3 8.96 7.78 20.01 7.78",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M31.34 28.58h-13.68c-.64 0-1.16-.53-1.16-1.17v-.94a4.88 4.88 0 0 1 4.86-4.87h6.28a4.88 4.88 0 0 1 4.86 4.87v.94c0 .64-.52 1.16-1.16 1.17v0Zm-6.84-12.79a4.65 4.65 0 1 1 0-9.3 4.65 4.65 0 0 1 0 9.3v0Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRefresh);
export default __webpack_public_path__ + "static/media/user-refresh.e1b08689f0ea241447f7aadd8749240e.svg";
export { ForwardRef as ReactComponent };